var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 21,
    height: 21,
    rx: 5,
    fill: "#E6ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.34068L9.57 13.0965C9.81645 13.3549 10.15 13.5 10.4978 13.5C10.8455 13.5 11.179 13.3549 11.4255 13.0965L15 9.33634L14.2046 8.5L10.6305 12.2598C10.5953 12.2968 10.5477 12.3176 10.4979 12.3176C10.4482 12.3176 10.4005 12.2968 10.3654 12.2598L6.79537 8.50435L6 9.34068Z",
    fill: "#030304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop-down.8cb6e4c56b6c8c61b5e325dbcbb3f89c.svg";
export { ForwardRef as ReactComponent };